module.exports = __webpack_public_path__ + "836bb018ee48a1f10c5fcc4f81ca6c27.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-38.cur
// module id = 455
// module chunks = 0